/**
 * Tulia Product Card — Option A interactions
 * Handles:
 * 1. Swatch active state toggling + color name update
 * 2. Product image swap when a swatch is selected (issue #64)
 *
 * Quick-add is handled by Dawn's built-in <modal-opener> / <product-form>
 * web components (no custom JS needed for add-to-cart).
 *
 * Uses event delegation on document body to survive AJAX filter/sort reloads.
 */
(function () {
  'use strict';

  var SWATCH_SELECTOR = '.tulia-card__swatch';
  var ACTIVE_CLASS = 'tulia-card__swatch--active';
  var SRCSET_WIDTHS = [360, 533, 720, 940];

  /**
   * Build a srcset string from a Shopify CDN base URL (no width param)
   * by appending &width=N for each breakpoint up to the image's natural width.
   */
  function buildSrcset(baseUrl, naturalWidth) {
    var parts = [];
    for (var i = 0; i < SRCSET_WIDTHS.length; i++) {
      if (naturalWidth >= SRCSET_WIDTHS[i]) {
        parts.push(baseUrl + '&width=' + SRCSET_WIDTHS[i] + ' ' + SRCSET_WIDTHS[i] + 'w');
      }
    }
    parts.push(baseUrl + ' ' + naturalWidth + 'w');
    return parts.join(', ');
  }

  /**
   * Swap a card's <img> element src/srcset/dimensions from swatch data.
   */
  function swapImage(imgEl, src, width, height, alt) {
    if (!imgEl || !src) return;
    imgEl.src = src + '&width=720';
    imgEl.srcset = buildSrcset(src, width);
    imgEl.width = width;
    imgEl.height = height;
    if (alt != null) imgEl.alt = alt;
  }

  /**
   * Handle swatch click — toggle active state, update color name, swap images.
   */
  function handleSwatchClick(e) {
    var swatch = e.target.closest(SWATCH_SELECTOR);
    if (!swatch) return;

    // Prevent navigation — the swatch interaction swaps images in-place
    e.preventDefault();

    var card = swatch.closest('.tulia-card');
    if (!card) return;

    var swatchContainer = swatch.closest('.tulia-card__swatches');
    if (!swatchContainer) return;

    // Update active swatch
    swatchContainer.querySelectorAll(SWATCH_SELECTOR).forEach(function (s) {
      s.classList.remove(ACTIVE_CLASS);
    });
    swatch.classList.add(ACTIVE_CLASS);

    // Update color name label if present
    var colorName = card.querySelector('.tulia-card__color-name');
    if (colorName && swatch.title) {
      colorName.textContent = swatch.title;
    }

    // Swap primary image
    var variantImg = swatch.dataset.variantImg;
    if (variantImg) {
      var primaryEl = card.querySelector('.tulia-card__img:not(.tulia-card__img--secondary)');
      swapImage(
        primaryEl,
        variantImg,
        parseInt(swatch.dataset.variantImgW, 10),
        parseInt(swatch.dataset.variantImgH, 10),
        swatch.dataset.variantImgAlt
      );
    }

    // Swap secondary (hover) image if data is available
    var secImg = swatch.dataset.secondaryImg;
    if (secImg) {
      var secondaryEl = card.querySelector('.tulia-card__img--secondary');
      swapImage(
        secondaryEl,
        secImg,
        parseInt(swatch.dataset.secondaryImgW, 10),
        parseInt(swatch.dataset.secondaryImgH, 10),
        null
      );
    }
  }

  /**
   * Handle swatch hover — preview color name on mouseenter, revert on mouseleave.
   */
  function handleSwatchHover(e) {
    // Capture-phase listeners on document also fire when the pointer enters or
    // leaves the page itself; then e.target is the document, which has no .closest.
    if (!(e.target instanceof Element)) return;

    var swatch = e.target.closest(SWATCH_SELECTOR);
    if (!swatch) return;

    var card = swatch.closest('.tulia-card');
    if (!card) return;

    var colorName = card.querySelector('.tulia-card__color-name');
    if (!colorName) return;

    if (e.type === 'mouseenter' && swatch.title) {
      colorName.textContent = swatch.title;
    } else if (e.type === 'mouseleave') {
      var activeSwatch = card.querySelector('.' + ACTIVE_CLASS);
      if (activeSwatch && activeSwatch.title) {
        colorName.textContent = activeSwatch.title;
      }
    }
  }

  /**
   * Main click handler — delegated on document body.
   */
  function handleClick(e) {
    if (e.target.closest(SWATCH_SELECTOR)) {
      handleSwatchClick(e);
    }
  }

  function init() {
    document.addEventListener('click', handleClick);
    document.addEventListener('mouseenter', handleSwatchHover, true);
    document.addEventListener('mouseleave', handleSwatchHover, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
